const ExportDataList = () => import('Views/userCenter/export-data-list');

export default[
  { path: '/export-data-list', component: ExportDataList },
];



// WEBPACK FOOTER //
// ./src/router/exportData.js